import { render } from "./category-variables-tab.vue?vue&type=template&id=70c4a8e1&scoped=true"
import script from "./category-variables-tab.vue?vue&type=script&lang=js"
export * from "./category-variables-tab.vue?vue&type=script&lang=js"

import "./category-variables-tab.vue?vue&type=style&index=0&id=70c4a8e1&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c4a8e1"]])

export default __exports__